import { isBizNull } from "./dom";
export const getType = (object) => {
  return Object.prototype.toString.call(object);
};

export const isNull = (object) => {
  return object === null || object === undefined;
};

 
export const getSwedenTime = dateStr => {
  if (isBizNull(dateStr)) {
    return null;
  }
  return new Date(`${dateStr} GMT+0100`).getTime();
};

export const englishMonthTimer = (date) => {
  const monthArr = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const time = new Date(date);
  time.setHours(time.getHours() - 8);
  const month = time.getMonth();
  const day = time.getDate();
  const year = time.getFullYear();
  const monthEn = monthArr[month];
  const str = `${monthEn} ${day}, ${year}`;
  return str;
};
 